import { useSelector } from 'react-redux';
import { Box, Stack, Drawer, IconButton, useTheme } from '@mui/material';

import { NAV } from '@app/configs';
import { Iconify, LogoSidebar } from '@app/components';
import Scrollbar from '@app/components/scrollbar/Scrollbar';
import NavSectionVertical from '@app/components/nav-section/vertical/NavSectionVertical';
import useResponsive from '@app/hooks/use-responsive';
import { Strings } from '@app/constants';
import { selectLoginState } from '@app/modules/auth/selectors';
import navConfig from './config-navigation';
import NavAccount from './NavAccount';
import { CloseIconStyled } from '../style';

// ----------------------------------------------------------------------

interface Props {
  openNav: boolean;
  onCloseNav: VoidFunction;
}

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const isMobile = useResponsive('down', 'sm');
  const theme = useTheme();
  const userData = useSelector(selectLoginState);

  const roleName = userData?.data?.role?.name ?? 'N/A';
  const filteredNavConfig = navConfig.filter(
    (item) => item && (roleName !== 'Local User' || item.title !== Strings.sidebar.users)
  );

  const renderContent = (
    <Stack
      sx={{
        background: theme.palette.primary.light,
      }}
    >
      <Scrollbar
        sx={{
          height: '100vh',
          '& .simplebar-content': {
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <CloseIconStyled>
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={onCloseNav}>
            <Iconify icon="fluent-emoji-high-contrast:cross-mark" />
          </IconButton>
        </CloseIconStyled>
        <Stack sx={{ my: 2 }}>
          <LogoSidebar disabledLink sx={{ height: isMobile ? 70 : 102, width: 120 }} />
        </Stack>

        <Stack sx={{ mx: 2, my: 4, flexGrow: 1 }}>
          <NavSectionVertical sx={{ flexGrow: 1 }} data={filteredNavConfig} />
        </Stack>

        <Stack sx={{ mx: 2.5, pb: 3 }}>
          <NavAccount />
        </Stack>
      </Scrollbar>
    </Stack>
  );
  return (
    <Box
      component="nav"
      // sx={{
      //   width: { lg: NAV.W_DASHBOARD },
      // }}
    >
      <Drawer
        anchor="left"
        open={openNav}
        onClose={onCloseNav}
        variant={isMobile ? 'temporary' : undefined}
        PaperProps={{
          sx: {
            zIndex: 0,
            width: NAV.W_DASHBOARD,
            position: 'relative',
            display: openNav || !isMobile ? 'visible' : 'none',
          },
        }}
      >
        {renderContent}
      </Drawer>
    </Box>
  );
}
